webpackJsonp([247051255376705],{

/***/ 775:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/cetacean-olympics-controversy/"},"excerpt":"The whale team is protesting the presence of the Japanese judges at the recent Cetacean Olympics after one of the Japanese judges attempted…","timeToRead":1,"frontmatter":{"title":"Cetacean Olympics Controversy","tags":["acrobatics","cetaceans","olympics","whales"]}}}]}},"pathContext":{"tag":"whales"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-whales-cef50843fcd6ee271cd3.js